export const parentColumnGroups = [
    { label: "Scheme Info", span: 3, }, // width: "280px" },
    { label: "pNAV Rank", span: 2, },   // width: "110px"  },
    { label: "CAGR %", span: 1, },     //width: "110px" },
    { label: "% Change", span: 2, },   //width: "100px" },
    { label: "Annualized Returns", span: 2, }  // width: "100px" }
];

export const pcTableDisplayColumns = [
    { field: "name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "string",},
    { field: "launchDate", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "Date",},
    { field: "stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based number of Years and Assets under Management",
              sortable: false, parent: true, child: true, JStype: "string",},
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "50px",
              tooltip: "Higher Rank of Scheme based on predicted performance in last 2 months",
              sortable: false, parent: true, child: true, JStype: "number", },
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "50px",
              tooltip: "Other Rank of Scheme based on predicted performance in last 2 months",
              sortable: false, parent: true, child: true, JStype: "number", },
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual', 
              label2: 'CAGR % as of Last Actual', width: "60px",
              tooltip: "", sortable: true, parent: true, child: true, JStype: "number", },
    { field: "change7d", label: 'in 7 Days', label2: '% Change in 7 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: "change30d", label: 'in 30 Days', label2: '% Change in 30 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: "change180d", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: 'annualizedReturns1', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year', width: "40px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "number", },    
    { field: 'annualizedReturns3', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "number", },    
  ];
export const parentColumns = [ 
    { field: "name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: true,},
    { field: "launchDate", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false,},
    { field: "stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based on - Scheme Launch Date (Age) and AUM",
              sortable: false,},
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "40px",
              tooltip: "Higher Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "40px",
              tooltip: "Other Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual',
              label2: 'CAGR % as of Last Actual', width: "60px", tooltip: "", sortable: true,},
    { field: "change7d", label: 'in 7 Days', label2: '% Change in 7 Days', 
              width: "40px", tooltip: "", sortable: true,},
    { field: "change30d", label: 'in 30 Days', label2: '% Change in 30 Days', 
              width: "40px", tooltip: "", sortable: true,},
    { field: "change180d", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: true,},
    { field: 'annualizedReturns1', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year',  width: "40px", tooltip: "",
              sortable: true,},
    { field: 'annualizedReturns3', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px", tooltip: "",
              sortable: true,},    
  ];
export const parentDetailsColumns = [ 
    { field: "name", label: 'Scheme Name' },
    { field: "navBaseValueDate", label: 'NAV base value Date' },
    { field: "lastActualNav", label: 'Last Known Actual NAV' },
    { field: "lastActualNavDate", label: 'Last Known Actual NAV Date' },
    { field: 'change90d', label: '% Change in 90 Days' },
    { field: 'annualizedReturns5', label: 'Annualized returns in last 5 year' },

  ];
export const childColumns = [ 
    { field: "name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: true, },
    { field: "launchDate", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false, },
    { field: "stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based on - Scheme Launch Date (Age) and AUM",
              sortable: false, },
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "40px",
              tooltip: "Best Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "40px",
              tooltip: "Other Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual',
              label2: 'CAGR % as of Last Actual', width: "60px", tooltip: "", sortable: true, },
    { field: "change7d", label: 'in 7 Days', label2: '% Change in 7 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: "change30d", label: 'in 30 Days', label2: '% Change in 30 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: "change180d", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: 'annualizedReturns1', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year',  width: "40px", tooltip: "",
              sortable: true,},
    { field: 'annualizedReturns3', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px", tooltip: "",
              sortable: true, },    
  ];